import React from 'react';
import { ChevronDown } from 'lucide-react';

export default function CrmChatNewMessagesPill({ count, onClick }) {
  if (!count || count < 1) return null;

  const label = count === 1 ? '1 new message' : `${count} new messages`;

  return (
    <button
      type="button"
      onClick={onClick}
      className="absolute bottom-3 left-1/2 -translate-x-1/2 z-20 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-600 text-white text-xs font-medium shadow-lg hover:bg-emerald-700 transition-colors animate-in fade-in slide-in-from-bottom-2 duration-200"
    >
      <ChevronDown className="h-3.5 w-3.5" />
      {label}
    </button>
  );
}
